import React, { useEffect, useState } from "react";
import {
  breakpoints,
  useMediaQuery,
  Header,
  Paragraph,
  Saddle,
  useColorTokens
} from "@tvg/design-system";
import {
  HorseInfoContainer,
  PayoutContainer,
  PayoutValuesContainer,
  PositionContainer,
  RunnerResultContainer,
  SaddleContainer,
  DNF
} from "./styled-components";
import { RunnerResultProps } from "./types";
import { numberOfColumnsPayout } from "../../../utils/numberOfColumnsPayout";

const RunnerResult = ({
  horseName,
  horseSaddleInfo,
  jockeyName,
  trainerName,
  resultPayouts,
  lengthToNextRacer,
  racerComment,
  isWinner = false,
  position,
  isDriver,
  animatedStyles = {},
  qaLabel = "runner-result-item"
}: RunnerResultProps) => {
  const colorTokens = useColorTokens();
  const isDesktopMinLg = useMediaQuery(breakpoints.desktop.min.lg);
  const numberOfTitleChars = isDesktopMinLg ? 50 : 20;
  const isDnf = position === "99th";
  const [numberOfColumns, setNumberOfColumns] = useState(0);
  useEffect(() => {
    setNumberOfColumns(numberOfColumnsPayout(resultPayouts));
  }, [resultPayouts]);

  return (
    <RunnerResultContainer data-qa-label={qaLabel} style={animatedStyles}>
      <SaddleContainer>
        <Saddle
          number={horseSaddleInfo.number}
          numberColor={horseSaddleInfo.numberColor}
          saddleColor={horseSaddleInfo.saddleColor}
          size="m"
          fullHeight
        />
      </SaddleContainer>
      <HorseInfoContainer>
        <PayoutContainer>
          <PositionContainer>
            {isDnf ? (
              <DNF>DNF</DNF>
            ) : (
              <Header
                qaLabel="position-text"
                tag="h3"
                lineHeight="18px"
                fontSize="s"
                fontFamily="bold"
                color={
                  isWinner
                    ? colorTokens.background.positive
                    : colorTokens.content.default
                }
              >
                {position}
              </Header>
            )}
            {lengthToNextRacer && (
              <Paragraph qaLabel="length-text" ml="space-3">
                {lengthToNextRacer}
              </Paragraph>
            )}
          </PositionContainer>
          <PayoutValuesContainer numberOfColumns={numberOfColumns}>
            {!!resultPayouts.win && (
              <Paragraph
                qaLabel="payout-win"
                fontFamily="medium"
                textAlign="right"
              >
                {resultPayouts.win}
              </Paragraph>
            )}
            {!!resultPayouts.place && (
              <Paragraph
                qaLabel="payout-place"
                fontFamily="medium"
                fontStyle="normal"
                textAlign="right"
              >
                {resultPayouts.place}
              </Paragraph>
            )}

            {resultPayouts.show && (
              <Paragraph
                qaLabel="payout-show"
                fontFamily="medium"
                textAlign="right"
              >
                {resultPayouts.show}
              </Paragraph>
            )}
          </PayoutValuesContainer>
        </PayoutContainer>
        <Header
          tag="h3"
          fontFamily="medium"
          color="inherit"
          qaLabel="horse-name"
        >{`${horseName.substring(0, numberOfTitleChars)}${
          horseName.length > numberOfTitleChars ? "..." : ""
        }`}</Header>
        <Paragraph
          qaLabel="jockey-trainer-name"
          color={colorTokens.content.subtle}
          mt="space-1"
        >
          {`${isDriver ? "D" : "J"}: ${jockeyName} | T: ${trainerName}`}
        </Paragraph>
        {racerComment ? (
          <Paragraph
            qaLabel="racer-comment-text"
            mt="space-3"
            color={colorTokens.content.subtle}
          >
            {racerComment}
          </Paragraph>
        ) : null}
      </HorseInfoContainer>
    </RunnerResultContainer>
  );
};

export default RunnerResult;
